import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export enum WalletTransactionType {
  DEPOSIT = 'Depósito',
  WITHDRAW = 'Retirada',
  REFOUND = 'Estorno'
}
export enum TransactionStatus {
  PENDING = 'Pendente',
  RECEIVED = 'Recebido',
  REFOUND = 'Reembolso',
  EXPIRED = 'Expirado'
}

export type AnalyticReportDto = {
  w_t_id: number,
  w_t_amount: number
  w_t_type: string
  w_t_status: string
  w_t_createdAt: Date

  w_t2_id: number
  w_t2_amount: number
  w_t2_type: string
  w_t2_status: string
  w_t2_createdAt: Date
  w_t2_origin_id: string

  w_t3_id: number
  w_t3_amount: number
  w_t3_type: string
  w_t3_status: string
  w_t3_createdAt: Date
  w_t3_origin_id: number

  t_amount: number
  t_indication_id: number
  t_payment_link: string
  t_status: string
  t_created_at: Date
  patient_name: string

  documentUrl: string 
  attendanceStatus: string 
}

export type AnalyticReportFixed = {
  id: number | null;
  indicationId: number | null;
  amount: number | null;
  type: string | null;
  status: string | null;
  createAt: Date | string | null;
  paymentLink: string | null;
  refundId?: number | null;
  refundAmount?: number | null;
  typeRefund?: string | null;
  statusRefund?: string | null;
  createAtRefund?: Date | null;
  patientName: string | null;
  payment_method?: string;
  documentUrl?: string | null;
  attendanceStatus?: string | null;
};

@Injectable({
  providedIn: 'root'
})
export class WalletTransactionsService {
  private readonly baseUrl = `${environment.api}/wallet-transactions`;
  constructor(private readonly http: HttpClient) { }

  analyticReportTransactions(params?: {limit: number, skip: number}): Observable<AnalyticReportDto[]> {
    const query = params ? new HttpParams().set('limit', params.limit).set('skip', params.skip): null;
    return this.http.get<AnalyticReportDto[]>(`${this.baseUrl}/analytic-report`, {params: query });
  }

  downloadCsv(): Observable<any> {
    return this.http.get(`${this.baseUrl}/download-report`, {
      responseType: 'blob'
    });
  }
}
